import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    // CSRF protection: custom header forces preflight from foreign origins,
    // which our strict CORS policy rejects. Same-origin (this app) is unaffected.
    "X-Requested-With": "XMLHttpRequest",
  },
});

export default api;
